
export default {
    getAsPath() {
        const params = new URLSearchParams(window.location.search);
        return params.get('redirectPath')
    },

    getAsQueryString() {
        const redirectPath = this.getAsPath()
        return (redirectPath !== null) ? `?redirectPath=${redirectPath}` : ''
    }
}
